#import "./user-permissions-fragment.graphql"

fragment User on User {
    id
    name
    isAdministrator
    sendableEmailAddresses {
        ...UserEmailAddress
    }
    emailAddresses {
        ...UserEmailAddress
    }
    emailSignature
    isEmailTrackingEnabled
    permissions {
        ...UserPermissionsFragment
    }
}

fragment UserEmailAddress on UserEmail {
    id
    address
    formatted
    isSyncEnabled
    isEnabledForSending
}
